import Page from '../components/page';
import TextSlideShow from '../components/shared/textSlideShow';
import { serverSideTranslations } from '../lib/serverSideTranslations';
import { useTranslation } from '../utils/i18n';

const AboutPage = () => {
  const { t } = useTranslation('common');

  // The i18n catalogue stores the testimonials as an array of objects.
  const testimonials = t('testimonials.items', {
    returnObjects: true,
  }) as Array<{ quote: string; by: string }>;

  return (
    <Page
      title={t('headers.about_page.title')}
      description={t('headers.about_page.description')}
    >
      <main className="about-page">
        <div className="banner" data-cy="banner">
          <div className="banner__content">
            <p>{t('about.intro')}</p>
          </div>
        </div>
        <div className="about-page__wrapper">
          <div className="about-page__explanation">
            <p>{t('about.explanation_first_paragraph')}</p>
            <p>{t('about.explanation_second_paragraph')}</p>
            <p>{t('about.explanation_third_paragraph')}</p>
            <p>{t('about.explanation_fourth_paragraph')}</p>
            <p>{t('about.explanation_fifth_paragraph')}</p>
            <h3>{t('about.right_space.heading')}</h3>
            <p>{t('about.right_space.explanation')}</p>

            <div className="about-page__explanation__roomTypes">
              <div style={{ flex: 1 }}>
                <b>{t('about.right_space.clinical.heading')}</b>
                <ul>
                  <li>{t('about.right_space.clinical.minor_operations')}</li>
                  <li>{t('about.right_space.clinical.treatment')}</li>
                  <li>{t('about.right_space.clinical.examination')}</li>
                  <li>{t('about.right_space.clinical.consulting')}</li>
                </ul>
              </div>

              <div style={{ flex: 1 }}>
                <b>{t('about.right_space.non_clinical.heading')}</b>
                <ul>
                  <li>{t('about.right_space.non_clinical.counselling')}</li>
                  <li>{t('about.right_space.non_clinical.group')}</li>
                  <li>{t('about.right_space.non_clinical.meeting')}</li>
                  <li>{t('about.right_space.non_clinical.office')}</li>
                </ul>
              </div>
            </div>

            <br />

            <br />
            <p>{t('about.right_space.explanation_first_paragraph')}</p>
            <p>{t('about.right_space.explanation_second_paragraph')}</p>
            <h3>{t('about.how_it_works.heading')}</h3>
            <p>{t('about.how_it_works.explanation_first_paragraph')}</p>
            <p>{t('about.how_it_works.explanation_second_paragraph')}</p>
            <p>{t('about.how_it_works.explanation_third_paragraph')}</p>
            <p>{t('about.how_it_works.explanation_fourth_paragraph')}</p>
            <p>{t('about.how_it_works.explanation_fifth_paragraph')}</p>
            <p>{t('about.how_it_works.explanation_sixth_paragraph')}</p>
            <p>{t('about.how_it_works.explanation_seventh_paragraph')}</p>
            <h3>{t('about.need_some_help.heading')}</h3>
            <p>
              Our dedicated support team is on hand to make sure you get the
              most out of NHS Open Space. Contact our Customer Service Centre on
              0808 196 2045 or&nbsp;
              <a href="mailto:customer.service@property.nhs.uk">
                customer.service@property.nhs.uk
              </a>
              &nbsp; and we&apos;d be happy to help.
            </p>
          </div>
          <div className="video-block">
            <div className="video-block__wrapper">
              <iframe
                title="vimeo-player"
                data-cookieblock-src={t('vimeo-player.source')}
                data-cookieconsent="marketing"
                width="100%"
                height="100%"
                frameBorder="0"
                allowFullScreen
              />
            </div>
            <div className="video-block__intro">
              <p>{t('about.video_text')}</p>
              <button className="button button--primary button--center">
                <a
                  href="https://www.property.nhs.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('about.property_services')}
                </a>
              </button>
            </div>
          </div>
        </div>
        <div className="testimonials-slideshow">
          <h1>{t('testimonials.title')}</h1>
          <TextSlideShow slidesArray={testimonials} />
        </div>
      </main>
    </Page>
  );
};

export const getServerSideProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default AboutPage;
